/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Table, Button, Card, Row, Col, Typography, Breadcrumb } from "antd";
import { ArrowLeftOutlined, DownloadOutlined, HomeOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

import { HubCPOverviewService } from "../../../../services/api/hubCPOverviewService";

const { Title } = Typography;

const InboundPendencyClickableReport = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // eslint-disable-next-line
    const { hubId, fromDate, toDate, bookingDateFrom, bookingDateTo } = location.state || {};
    console.log("InboundPendency - hubId:", hubId, "location.state:", location.state);

    // eslint-disable-next-line
    const [data, setData] = useState([]);
    // eslint-disable-next-line
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

    const columns = [
        {
            title: "Sr no",
            dataIndex: "srNo",
            key: "srNo",
            render: (_, __, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
            width: 80,
        },
        {
            title: "Tracking no",
            dataIndex: "trackingNo",
            key: "trackingNo",
            width: 150,
            render: (text) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        if (text) {
                            const url = `/shipment-tracker?awb=${text}`;
                            window.open(url, "_blank");
                        }
                    }}
                >
                    {text || "-"}
                </span>
            ),
        },
        {
            title: "Trip ID",
            dataIndex: "tripId",
            key: "tripId",
            width: 150,
            render: (text, record) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        if (text) {
                            const recordToStore = {
                                ...record,
                                vehicle_lcr_id: text,
                            };
                            sessionStorage.setItem("LCR_REPORT_RECORD", JSON.stringify(recordToStore));
                            window.open(window.location.origin + "/lcr-report", "_blank");
                        }
                    }}
                >
                    {text || "-"}
                </span>
            ),
        },
        {
            title: "Stop ID",
            dataIndex: "stopId",
            key: "stopId",
            width: 150,
            render: (text, record) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        if (text) {
                            const recordToStore = {
                                ...record,
                                vehicle_lcr_id: text,
                            };
                            sessionStorage.setItem("LCR_REPORT_RECORD", JSON.stringify(recordToStore));
                            window.open(window.location.origin + "/lcr-report", "_blank");
                        }
                    }}
                >
                    {text || "-"}
                </span>
            ),
        },
        {
            title: "Trip Departed At",
            dataIndex: "tripDepartedAt",
            key: "tripDepartedAt",
            width: 180,
        },
        {
            title: "Trip Received At",
            dataIndex: "tripReceivedAt",
            key: "tripReceivedAt",
            width: 180,
        },
        {
            title: "From Hub",
            dataIndex: "fromHub",
            key: "fromHub",
            width: 180,
        },
        {
            title: "Mode",
            dataIndex: "mode",
            key: "mode",
            width: 120,
        },
    ];

    const fetchData = async (pageNum = 1, pageSize = 10) => {
        console.log("InboundPendency - fetchData called with:", { pageNum, pageSize, hubId });
        // if (!hubId) return; // Removed strict check

        try {
            setLoading(true);
            const params = {
                tripEndHubId: hubId,
                page: pageNum - 1, // API uses 0-based indexing
                size: pageSize,
                fromDate,
                toDate,
                bookingDateFrom,
                bookingDateTo,
            };

            const response = await HubCPOverviewService.getInboundPendencyClickable(params);
            console.log("InboundPendency - API response:", response);

            if (response && response.data) {
                setData(response.data);
                setPagination((prev) => ({
                    ...prev,
                    current: pageNum,
                    pageSize: pageSize,
                    total: response.count || 0,
                }));
            } else {
                setData([]);
                setPagination((prev) => ({ ...prev, total: 0 }));
            }
        } catch (error) {
            console.error("Error fetching inbound pendency data:", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(pagination.current, pagination.pageSize);
    }, [hubId, fromDate, toDate, bookingDateFrom, bookingDateTo]);

    const handleTableChange = (newPagination) => {
        // Update pagination logic 
        setPagination({ ...pagination, ...newPagination });
        fetchData(newPagination.current, newPagination.pageSize);
    };

    const handleDownload = async () => {
        try {
            setDownloadLoading(true);
            const params = {
                tripEndHubId: hubId,
                fromDate,
                toDate,
                bookingDateFrom,
                bookingDateTo,
            };
            const url = await HubCPOverviewService.getInboundPendencyClickableDownload(params);
            if (url) {
                window.open(url, "_blank");
            }
        } catch (error) {
            console.error("Error downloading report:", error);
        } finally {
            setDownloadLoading(false);
        }
    };

    return (
        <div className="hub-manager-shipment-details" style={{ padding: "20px" }}>
            <Breadcrumb separator=">">
                <Breadcrumb.Item onClick={() => navigate("/dashboard")} style={{ cursor: "pointer" }}>
                    <HomeOutlined /> Dashboard
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                    Hub Manager Overview
                </Breadcrumb.Item>
                <Breadcrumb.Item>Inbound Pendency</Breadcrumb.Item>
            </Breadcrumb>

            <Card style={{ marginTop: "16px" }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: "16px" }}>
                    <Col>
                        <Title level={4} style={{ margin: 0 }}>
                            <Button
                                icon={<ArrowLeftOutlined />}
                                onClick={() => navigate(-1)}
                                style={{ marginRight: "16px", border: "none", background: "transparent" }}
                            />
                            Inbound Pendency
                        </Title>
                    </Col>
                    <Col>
                        {/* Download button functionality to be added later */}
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            onClick={handleDownload}
                        >
                            Download Report
                        </Button>
                    </Col>
                </Row>

                <Table
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    onChange={handleTableChange}
                    rowKey="trackingNo"
                    scroll={{ x: 1200 }}
                />
            </Card>
        </div>
    );
};

export default InboundPendencyClickableReport;
